<template>
    <div>
        <div id="quote">
            <p>this is where I keep notes on my projects, fun books, or anything else I find interesting and noteworthy</p>
            <h5><i>welcome to the jungle</i></h5>
        </div>
    </div>
</template>

<script>

export default {
}
</script>

<style scoped>
    #quote {
      background-color: #303030;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      min-height: 15vh;
      border-bottom: 2px solid #F7F7F7;
    }
    #quote p {
        margin-bottom: 15px;
        font-size: 1.2rem;
        font-weight: 800;
        color: white;
        text-align: center;
    }
    #quote h5 {
        color: darkgray;
        font-size: 1.1rem;
        margin-bottom: 5px;
    }
    p {
        color: white;
        margin-bottom: 0px;
    }
</style>